import { arrayBuffer } from '../../../app-core/lib/upload/buffer'
import type { CordovaFile } from '../../../app-core/lib/upload/cordovaSelectSaveAndUpload'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import { writeArrayBufferToDisk } from './writeArrayBufferToDisk'

export const writeCordovaFileContentToDisk = async (fileId: FileId, data: CordovaFile) =>
    writeArrayBufferToDisk(fileId, arrayBuffer(data.data.buffer))
